export default {
  toasts: {
    success: 'Cadeaukaart succesvol ingewisseld.',
    error: 'Inwisselen van cadeaukaart mislukt.',
  },
  title: 'Cadeaukaart inwisselen',
  subtitle: 'Voer de cadeaukaartcode en het in te wisselen bedrag van de rekening in.',
  form: {
    amount: {
      label: 'In te wisselen bedrag',
    },
    code: {
      label: 'Cadeaukaartcode',
    },
  },
  buttons: {
    redeem: 'Inwisselen',
    cancel: 'Annuleren',
  },
};
